<template lang="pug">
  .chart.size.relative
    h3.title-medium.m-bottom-3
      | {{ $t('stats.resourceMoreValued.title') }}
    .chart-card
      .relative
        loader.loader.absolute(v-if='isLoading' size='inner' whiteBackground)
        .chart-container(ref='chartdiv')
      .chart-footer.row.start
        span.title-medium.slim.no-info.middle(v-if='!info.length')
          | {{ $t('stats.resourceMoreValued.noInfo') }}
        .column.reference-1.m-left-2.m-bottom-2(v-else v-for='(aspect, index) in info' :key='aspect.id')
          p.text-xsmall.dark-gray.aspect-color.row.middle(:style='getAspectStyle(index)')
            | {{ $t(`stats.aspectResource.${aspectResourceOptions[aspect.category-1].category}`) }}
          span.title-medium.slim.m-left-1
            | {{ roundToTwo(aspect.value) }}%
        .column.reference-1.m-left-2.m-bottom-2(v-if='!info.length' v-for='(aspect, index) in aspectResourceOptions' :key='aspect.id')
          p.text-xsmall.dark-gray.aspect-color.row.middle(:style='getAspectStyle(index)')
            | {{ $t(`stats.aspectResource.${aspect.category}`) }}
          span.title-medium.slim.m-left-1
            | {{ aspect.value }} %
      .card-footer
        .column.m-right-2
          span.text-xsmall.dark-gray
            | {{ $t('stats.chartOptions.category') }}
          k-select.filter-content.selector.m-top-1(
            name='category'
            :options='getTranslatedOptions(categoryOptions)'
            keyName='value'
            :emptyOption='$t("stats.allCategories")'
            noSpacing
            :preselectedOption='filters.category'
            @selectOption='updateFilter'
          )
        .column(v-if='isAdminUser || isTrial')
          span.text-xsmall.dark-gray
            | {{ $t('stats.chartOptions.school') }}
          k-select.filter-content.m-top-1(
            name='schoolId'
            :options='schools'
            keyName='value'
            :emptyOption='$t("stats.allSchools")'
            noSpacing
            @selectOption='updateFilter'
          )
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import amplitude from 'amplitude-js'

import stats from '../../mixins/stats'
import userRole from '../../mixins/userRole'
import KSelect from '@/components/KSelect'
import Loader from '@/components/Loader'

import { pieChartConfiguration } from '../../config/charts/pieChartConfig'
import { aspectResourceOptions, emptyGraphic, resourcesMoreValuedColors } from '../../utils/constants'
import { roundToTwo } from '../../utils/round'

export default {
  mixins: [stats, userRole],
  data() {
    return {
      filters: {
        schoolId: null,
        category: null
      },
      aspectResourceOptions,
      emptyGraphic,
      colors: resourcesMoreValuedColors
    }
  },
  created() {
    this.updateChart()
  },
  mounted() {
    this.loadPieGraphic()
  },
  computed: {
    ...mapGetters({ info: 'getAspectOfMostValuedResources' }),
    ...mapState({
      isLoading: state => state.statistics.aspectOfMostValuedResourcesLoading
    })
  },
  methods: {
    ...mapActions([ 'getAspectsToDisplay' ]),
    getAspectStyle(index) {
      return {
        '--aspect-color': this.colors[index]
      }
    },
    async updateChart() {
      amplitude.getInstance().logEvent('Filter Statistics', {
        chartName: 'More valued resourced',
        filters: this.filters
      })
      await this.getAspectsToDisplay(this.filters)
      this.loadPieGraphic()
    },
    loadPieGraphic() {
      if (this.info.length) pieChartConfiguration(this.$refs.chartdiv, false, this.info, this.colors)
      else pieChartConfiguration(this.$refs.chartdiv, true, this.emptyGraphic)
    },
    roundToTwo
  },
  components: { KSelect, Loader }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.relative {
  position: relative;
}

.no-info {
  position: absolute;
  right: 60px;
  top: 240px;
  width: 330px;
}

.reference-1 {
  max-width: 130px;
  width:100%;
}

.aspect-color {
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    background-color: var(--aspect-color);
    border-radius: 4px;
    height: 7px;
    position: absolute;
    margin-right: 10px;
    width: 7px;
    left: 0px;
  }
}

.selector {
  max-width: 220px;
  width: 100%;
}

.chart-container {
 height: 400px;
 width: 100%;
}

.chart-card {
  background-color: $white;
  border: 1px solid $light-gray;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  border-radius: 10px;
}

.size {
  max-width: 480px;
  width: 100%;
}

.chart-footer {
  margin-top: 15px;
  flex-wrap: wrap;
  width: 100%;
}

.card-footer {
  align-items: center;
  border-top: 1px solid $light-gray;
  display: flex;
  height: 80px;
  padding: 10px 30px;
}

.filter-content {
  min-width: 180px;
}
</style>
